import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  // Layout
  urlBar: {
    background: '#16213e',
    padding: '16px 32px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    borderBottom: '1px solid #0f3460',
  },
  urlExtraGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    width: '100%',
  },
  urlBarLabel: {
    color: '#94a3b8',
    fontWeight: 600,
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: '10px',
  },
  labelSubtext: {
    opacity: 0.55,
    fontSize: '0.7rem',
    fontWeight: 400,
  },
  reqTextarea: {
    background: '#0f1f38',
    border: '1px solid #2d4a6e',
    borderRadius: '8px',
    height: '80px',
    overflow: 'auto',
  },
  container: {
    padding: '28px 32px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: '10px',
  },
  sectionTitle: {
    fontSize: '12px',
    fontWeight: 1000,
    letterSpacing: '1px',
    textTransform: 'uppercase',
    color: '#6b7280',
    marginBottom: '12px',
    paddingTop: '10px',
    marginRight: '10px',
  },
  // Meta pills
  metaPills: {
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
  },
  metaPill: {
    background: '#335977',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    borderRadius: '20px',
    padding: '4px 14px',
    fontSize: '0.76rem',
    color: 'rgba(255, 255, 255, 0.85)',
    whiteSpace: 'nowrap',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
  },
  metaPillStrong: {
    color: '#fff',
    fontWeight: 'bold',
  },
  // Filter bar
  filterBar: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flexWrap: 'wrap',
    padding: '14px 0 16px 0',
  },
  filterInput: {
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    color: '#374151',
    width: '400px',
    paddingLeft: '20px',
  },
  resultCount: {
    fontSize: '0.78rem',
    color: '#6b7280',
    fontWeight: 600,
    marginLeft: 'auto',
  },
  clearBtn: {
    padding: '5px 13px',
    background: '#f3f4f6',
    color: '#374151',
    border: '1px solid #e5e7eb',
    borderRadius: '7px',
    fontSize: '0.78rem',
    fontWeight: 600,
    cursor: 'pointer',
    '&:hover': {
      background: '#e5e7eb',
    },
  },
  // Card & Table wrapper
  card: {
    background: '#fff',
    borderRadius: '12px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.08), 0 4px 16px rgba(0,0,0,0.06)',
    overflow: 'hidden',
    marginBottom: '20px',
  },
  tableWrap: {
    overflowX: 'auto',
  },
  // Buttons
  submitBtn: {
    padding: '5px 22px',
    background: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
    color: '#fff',
    borderRadius: '8px',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      opacity: 0.9,
    },
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
  },
  yearlyBtn: {
    padding: '5px 22px',
    background: 'linear-gradient(135deg, #7c3aed, #5b21b6)',
    color: '#fff',
    borderRadius: '8px',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      opacity: 0.9,
    },
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
  },
  exportPowerBtn: {
    background: 'linear-gradient(135deg, #065f46, #059669)',
    borderRadius: '7px',
    fontSize: '0.78rem',
    fontWeight: 700,
    color: '#fff',
    padding: '5px 13px',
    '&:hover': {
      opacity: 0.88,
    },
  },
  exportEnergyBtn: {
    background: 'linear-gradient(135deg, #7c3aed, #5b21b6)',
    borderRadius: '7px',
    fontSize: '0.78rem',
    fontWeight: 700,
    color: '#fff',
    padding: '5px 13px',
    '&:hover': {
      opacity: 0.88,
    },
  },
  // TableData required styles
  dischargeTable: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '0.84rem',
    '& thead th': {
      background: '#335977',
      padding: '11px 14px',
      textAlign: 'left',
      fontSize: '0.72rem',
      fontWeight: 700,
      letterSpacing: '0.6px',
      textTransform: 'uppercase',
      color: '#FFE784',
      borderBottom: '2px solid #e5e7eb',
      whiteSpace: 'nowrap',
    },
    '& tbody tr': {
      transition: 'background 0.15s',
      '&:hover': {
        background: '#f8fafc',
      },
    },
    '& tbody td': {
      padding: '12px 14px',
      borderBottom: '1px solid #f0f2f5',
      color: '#374151',
    },
    '& tbody tr:last-child td': {
      borderBottom: 'none',
    },
  },
  tableHeader: {
    fontWeight: 700,
    backgroundColor: '#335977',
    whiteSpace: 'nowrap',
  },
  isBold: {
    fontWeight: 700,
    color: '#FFFFFF',
  },
  sortContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '4px',
    cursor: 'pointer',
  },
  sortUp: {
    marginBottom: '-8px',
  },
  sortDown: {
    marginTop: '-4px',
  },
  active: {
    color: '#FFE784',
  },
  inactive: {
    color: '#b0bac6',
  },
  emptyTableContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '150px',
    flexDirection: 'column',
  },
  titleWrapper: {
    whiteSpace: 'nowrap',
    fontSize: '0.8rem',
  },
  numCell: {
    textAlign: 'right',
    fontVariantNumeric: 'tabular-nums',
  },
  // Total column
  totalColPower: {
    background: '#f0fdf4',
    color: '#166534',
    borderLeft: '2px solid #bbf7d0',
  },
  totalColEnergy: {
    background: '#f5f3ff',
    color: '#6d28d9',
    borderLeft: '2px solid #ddd6fe',
  },
  // Grand total row cells
  grandRowCellPower: {
    fontWeight: 700,
    background: '#fefce8',
    borderTop: '2px solid #fde68a',
  },
  grandRowCellEnergy: {
    fontWeight: 700,
    background: '#f5f3ff',
    borderTop: '2px solid #ddd6fe',
  },
  grandChipPower: {
    background: '#fde68a',
    color: '#92400e',
  },
  grandChipEnergy: {
    background: '#ddd6fe',
    color: '#4c1d95',
  },
  grandTotalPower: {
    color: '#92400e',
    fontSize: '0.95rem',
  },
  grandTotalEnergy: {
    color: '#4c1d95',
    fontSize: '0.95rem',
  },
  // Chips
  chip: {
    display: 'inline-block',
    padding: '2px 9px',
    borderRadius: '20px',
    fontSize: '0.78rem',
    fontWeight: 600,
  },
  chipOrange: {
    background: '#ffedd5',
    color: '#c2410c',
  },
  chipPurple: {
    background: '#ede9fe',
    color: '#5b21b6',
  },
  chipBlue: {
    background: '#dbeafe',
    color: '#1e40af',
  },
  chipZero: {
    background: '#f3f4f6',
    color: '#9ca3af',
  },
  chipDefault: {
    background: '#f3f4f6',
    color: '#374151',
  },
  // Toggle
  toggleGroup: {
    display: 'flex',
    borderRadius: '8px',
    overflow: 'hidden',
    border: '1px solid #e5e7eb',
    flexShrink: 0,
  },
  toggleBtn: {
    padding: '7px 18px',
    background: '#f3f4f6',
    color: '#374151',
    border: 'none',
    fontSize: '0.82rem',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'background 0.15s, color 0.15s',
    '&:hover': {
      background: '#e5e7eb',
    },
  },
  toggleBtnActive: {
    background: '#2563eb',
    color: '#fff',
    '&:hover': {
      background: '#2563eb',
    },
  },
  toggleBtnBorder: {
    borderLeft: '1px solid #e5e7eb',
  },
  // Mode banner
  modeBannerPower: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '3px 12px',
    borderRadius: '20px',
    fontSize: '0.75rem',
    fontWeight: 700,
    letterSpacing: '0.3px',
    background: '#ffedd5',
    color: '#c2410c',
  },
  modeBannerEnergy: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '3px 12px',
    borderRadius: '20px',
    fontSize: '0.75rem',
    fontWeight: 700,
    letterSpacing: '0.3px',
    background: '#ede9fe',
    color: '#6d28d9',
  },
}))

export { useStyles }
